import axios from 'axios';
import qs from 'qs';
import { baseApi } from 'project/api';
import { apiNames, notificationTypes, BaseComponent } from 'project/general';
import { getApiUrlByName } from 'project/helpers';
import { basketController } from 'project/basket';
import { QuantityComponent } from 'shared/quantity';
import { notificationService } from 'project/services';
import { SPINNER_SHOW_CLASS } from 'shared/spinner';
import { MemberDiscount } from 'shared/member-discount';
import React from 'react';
import { render } from 'preact';

class ProductComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.state = {
            variantId: null,
            isFetching: false,
        };
    }

    static getNamespace() {
        return 'product';
    }

    static getRequiredRefs() {
        return [
            'price'
        ];
    }

    onInit() {
        if (this.refs.select && !Array.isArray(this.refs.select)) {
            this.refs.select = [this.refs.select];
        }

        if (this.refs.select) {
            this.refs.select.forEach((selectRef) => {
                this.addListener(selectRef, 'change', this.onChangeSelect.bind(this, selectRef));
            });
        }

        if (this.refs.quantity) {
            this.quantityInstance = new QuantityComponent(this.refs.quantity);
            this.quantityInstance.init();
        }

        if (this.refs.addToBasket) {
            this.addListener(this.refs.addToBasket, 'click', this.onClickAddToBasket);
        }
    }

    onChangeSelect = (activeSelect) => {
        ProductComponent.turnOnControlLoadingState(activeSelect);
        this.fetchData().then(() => {
            ProductComponent.turnOffControlLoadingState(activeSelect);
        });
    };

    onClickAddToBasket = (e) => {
        e.preventDefault();
        this.addToBasket();
    };

    fetchData() {
        const filters = this.refs.select.map((selectRef) => selectRef.value);
        const queryString = '?' + qs.stringify({
            productId: this.options.productId,
            optionIds: filters
        });
        const url = getApiUrlByName(apiNames.PRODUCT_VARIANT) + queryString;

        if (this.source) {
            this.source.cancel();
        }

        const CancelToken = axios.CancelToken;
        this.source = CancelToken.source();

        return baseApi
            .get(url, {
                cancelToken: this.source.token
            })
            .then((res) => {
                if (res.data && res.data.success) {
                    this.state.variantId = res.data.data.id;
                    this.updateView(res.data.data);
                } else {
                    throw new Error(res.data.message);
                }
            })
            .catch((thrown) => {
                if (!axios.isCancel(thrown)) {
                    console.log(thrown);
                }

                this.updateQuantity(0, false);
                this.updateAddToBasket(false);
            });
    }

    addToBasket() {
        const order = {
            productId: this.options.productId,
            currentVariantId: this.state.variantId || this.options.currentVariantId,
            quantity: this.quantityInstance.getCurrent(),
            continueBrowsingUrl: this.options.continueBrowsingUrl
        };

        this.updateAddToBasket(false, true);

        basketController
            .addProduct(order)
            .then((data) => {
                if (data.validationErrors) {
                    this.showNotification(data.validationErrors);
                }
                this.updateAddToBasket(true, false);
            })
            .catch((err) => {
                this.updateAddToBasket(true, false);

                console.log(err);
            });
    }

    updateView(data) {
        if (!data) return;

        this.reRenderPrices(data.prices);

        if(this.refs.code) {
            this.refs.code.textContent = data.skuNumber;
        }

        if (this.refs.availability) {
            this.refs.availability.textContent = data.availabilityDescription;
        }

        this.updateQuantity(data.maximumAvailableQuantity, data.allowAddToBasket);
        this.updateAddToBasket(data.allowAddToBasket);
    }

    reRenderPrices(prices) {
        this.refs.price.innerHTML = '';
        render(<MemberDiscount model={prices} />, this.refs.price);
    }

    updateQuantity(maxQuantity, quantityEnabled) {
        if (!this.quantityInstance) return;

        if (quantityEnabled) {
            this.quantityInstance.enable();
        } else {
            this.quantityInstance.disable();
        }

        this.quantityInstance.setMax(maxQuantity);
    }

    updateAddToBasket(addToBasketEnabled, showSpinner) {
        if (!this.refs.addToBasket) return;

        this.refs.addToBasket.disabled = !addToBasketEnabled;

        if (showSpinner !== undefined) {
            this.refs.addToBasket.classList[showSpinner ? 'add' : 'remove'](SPINNER_SHOW_CLASS);
        }
    }

    showNotification(notifications) {
        if (!Array.isArray(notifications)) return;

        notifications.forEach((notification) => {
            notificationService.push({
                message: notification.message,
                type: notificationTypes.ERROR,
            });
        });
    }

    static turnOnControlLoadingState(element) {
        if (!(element instanceof HTMLElement)) {
            return;
        }
        element.parentNode.classList.add(SPINNER_SHOW_CLASS);
    }

    static turnOffControlLoadingState(element) {
        if (!(element instanceof HTMLElement)) {
            return;
        }
        element.parentNode.classList.remove(SPINNER_SHOW_CLASS);
    }
}

export default ProductComponent;
